<template>
    <div class="toast-container position-fixed bottom-0 start-50 translate-middle-x p-3" style="z-index: 999999">
        <div v-for="(toast, i) in toasts" :id="toast.uuid" :key="i"
             class="toast align-items-center text-white border-0 fade"
             data-autohide="false"
             :class="{'bg-success': toast.type === 'success', 'bg-danger': toast.type === 'error'}" role="alert"
             aria-live="assertive" aria-atomic="true">
            <div class="d-flex">
                <div class="toast-body" v-html="toast.content">
                </div>
                <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast"
                        aria-label="Close"></button>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
    data() {
        return {
            toastIds: [],
        }
    },
    computed: {
        ...mapState('toasts', [
            'toasts',
        ])
    },
    methods: {
        initToasts() {
            let $vm = this
            this.toastIds = [].slice.call(document.querySelectorAll('.toast')).map(function (toastEl) {
                if (!$vm.toastIds.includes(toastEl.id)) {
                    new bootstrap.Toast(toastEl, {}).show()
                }
                return toastEl.id
            })
        }
    },
    mounted() {
        this.initToasts()
    },
    updated() {
        this.initToasts()
    },
}
</script>

<style scoped>

</style>
